
export const app = {
    APP_BACKEND_BASE_URL: process.env.REACT_APP_BACKEND_BASE_URL,
    APP_IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL,
    BIGCOMMERCE_URL: process.env.REACT_APP_BIGCOMMERCE_URL,
    APP_REPLACE_URL : './assets/images/',
    IS_LIVE : true
}
